import { ChangeTyped } from '@damofire/data-commons';
import { Observable } from 'rxjs';
import { RepairMedia } from './repair.dto';

export abstract class ObservableRepairMediaService {
  abstract observeMediaByRepair(division: string, repairId: string): Observable<ChangeTyped<RepairMedia>[]>;
}
